
import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Leaf, Home, LogIn, FolderOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/auth";


const Header: React.FC = () => {
  const { user } = useAuth();

  return <header className="sticky top-0 z-50 w-full hero-dark-gradient text-on-hero border-b border-white/10 backdrop-blur-sm shadow-sm">
      <div className="flex h-16 items-center justify-between px-4 md:px-6">
        <div className="flex items-center gap-2">
          <Link to="/" className="flex items-center gap-2 font-semibold text-terracotta-500">
            <Leaf className="h-6 w-6" />
            <span className="hidden md:inline-block">Arbetsmiljökontrollen</span>
          </Link>
        </div>
        <nav className="flex items-center gap-2">
          <NavLink to="/" aria-label="Hem">
            {({ isActive }) => (
              <Button variant="ghost" size="sm" className={`gap-2 text-on-hero text-glow hover:bg-white/10 ${isActive ? 'bg-white/15' : ''}`}>
                <Home className="h-4 w-4 icon-on-hero" />
                <span className="hidden md:inline-block">Hem</span>
              </Button>
            )}
          </NavLink>

          {user ? <>
              <Link to="/app/dashboard">
                <Button variant="hero-outline" size="sm" className="gap-2 ml-2">
                  <FolderOpen className="h-4 w-4 icon-on-hero" />
                  <span className="sm:inline-block">Gå till appen</span>
                </Button>
              </Link>
            </> : <Link to="/auth">
              <Button variant="hero-outline" size="sm" className="gap-2 ml-2">
                <LogIn className="h-4 w-4 icon-on-hero" />
                <span className="sm:inline-block">Logga in</span>
              </Button>
            </Link>}
        </nav>
      </div>
    </header>;
};

export default Header;
